import { ASSIGNMENTS_CLIENT_ID, ASSIGNMENTS_CUSTOMER_HASH } from './constants';
export const createConfigExperiment = ({ projectId, variants, experimentId, context = {}, }) => ({
    experimentId,
    projectId,
    variants,
    assignmentKey: ASSIGNMENTS_CUSTOMER_HASH,
    context,
});
export const createConfigExperimentWithClientId = ({ projectId, variants, experimentId, context = {}, preAssignment = false, }) => ({
    experimentId,
    projectId,
    variants,
    assignmentKey: ASSIGNMENTS_CLIENT_ID,
    context,
    preAssignment,
});
//# sourceMappingURL=createConfigExperiment.js.map